import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center w-full space-y-4" }
const _hoisted_2 = { class: "flex items-center justify-between w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold" }, "Explore Tokens", -1)
const _hoisted_4 = { class: "flex items-center space-x-2" }
const _hoisted_5 = { class: "p-2 border border-gray-200 rounded-full border-1" }
const _hoisted_6 = { class: "p-2 border border-gray-200 rounded-full border-1" }
const _hoisted_7 = { class: "grid w-full grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_TokenCard = _resolveComponent("TokenCard")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, [
            _createVNode(_component_ChevronLeftIcon, { class: "w-2 h-2" })
          ]),
          _createElementVNode("button", _hoisted_6, [
            _createVNode(_component_ChevronRightIcon, { class: "w-2 h-2" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token) => {
          return (_openBlock(), _createBlock(_component_TokenCard, {
            key: token.username,
            token: token
          }, null, 8, ["token"]))
        }), 128))
      ])
    ])
  ]))
}